import { render, staticRenderFns } from "./familyWithXChildren.vue?vue&type=template&id=6b5e1932&"
import script from "./familyWithXChildren.vue?vue&type=script&lang=js&"
export * from "./familyWithXChildren.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports